import { withProps } from 'recompose';
import config from '../../config';

export default withProps({
  urlPattern: config.urlPatterns.time,
});



// WEBPACK FOOTER //
// ./src/app/hoc/WithTimeUrlPattern.js